'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default ['$scope', '$uibModalInstance', 'land', '$security', 'LandService', '$utils',
    function ($scope, $modalInstance, land, $security, LandService, $utils) {
        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.editing = editing;
        $scope.isShowEdit = isShowEdit;
        $scope.getExternalURI = LandService.getExternalURI;
        $scope.openPlaceAddressOnYandexMaps = function (addr) {
            $utils.searchOnYandexMaps(addr);
        }

        // инициализация
        init();

        // region Function

        function init() {
            $scope.edit = false;
            $scope.land = angular.copy(land);

            if (land == null || angular.equals({}, land) || land.id == null) {
                $scope.title = 'Создание нового земельного участка';
                $scope.edit = true;
            } else {
                $scope.title = 'Редактирование земельного участка № ' + $scope.land.regNum;
                $scope.edit = false;
            }
        }

        function ok() {
            $scope.land.ownershipFormId = $scope.land.ownershipForm
                ? $scope.land.ownershipForm.id
                : null;
            $modalInstance.close($scope.land);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        /**
         * Редактировать
         */
        function editing() {
            $scope.edit = true;
        }

        /**
         * Отображать кнопку редактировать?
         * @returns {boolean|*}
         */
        function isShowEdit() {
            return !$scope.edit && $security.isAllowWrite('/lands');
        }

        // endregion
    }];
